import { getEquipmentOptions } from "@/common/filter"
import { SvgImageEditor } from "@/components/SvgImageEditor"
import { NozzleEdges } from "@/components/forms/NozzleEdges/NozzleEdges"
import { updateEquipment } from "@/services/project/equipment/equipment.service"
import { SimiulatorEquipment } from "@/types/equipment"
import { Button, Form, Input, Select, Space } from "antd"
import InputNumber from "antd/lib/input-number"
import { memo, useEffect } from "react"
import { useNavigate, useOutletContext } from "react-router-dom"
import styles from "./index.module.less";
import classNames from "classnames"
import { CustomNozzles } from "@/components/forms/CustomNozzles/CustomNozzles"

export const EquipmentBasic = memo(() => {
  const navigate = useNavigate()
  const [equipment] = useOutletContext<[SimiulatorEquipment]>();
  const [form] = Form.useForm()

  useEffect(() => {
    form.setFieldsValue(equipment)
  }, [])

  const toList = () => {
    navigate('/admin/equipment/')
  }

  const onFinished = async (values) => {
    await updateEquipment(equipment.id, values)
    toList()
  }
  
  return <div>
    <div>Equipment Basic</div>
    <Form
      form={form}
      onFinish={onFinished}
      className={classNames('mt-4', styles.form)}
    >
      <Form.Item label='Name' name='name' rules={[{ required: true, message: 'Please enter nozzle name' }]}>
        <Input type='text' />
      </Form.Item>

      <Form.Item label='Width' name='width' rules={[{ required: true, message: 'Please enter image width' }]}>
        <InputNumber type='number' style={{width: '100%'}} />
      </Form.Item>

      <Form.Item label='Height' name='height' rules={[{ required: true, message: 'Please enter image height' }]}>
        <InputNumber type='number' style={{width: '100%'}} />
      </Form.Item>

      <Form.Item label='Type' name='type' rules={[{ required: true, message: 'Please selected a nozzle type' }]}>
        <Select options={getEquipmentOptions()} />
      </Form.Item>

      <Form.Item label='SVG Image' name='image'>
        <SvgImageEditor disableClassName={styles.equipImage} />
      </Form.Item>

      <Form.Item label='Nozzle Edges' name='nozzleEdges'>
        <NozzleEdges />
      </Form.Item>

      <Form.Item label='Custom Nozzles' name='customNozzles'>
        <CustomNozzles />
      </Form.Item>

      <div className="flex-end">
        <Space>
          <Button htmlType="button" type="default" onClick={toList}>Cancel</Button>
          <Button htmlType="submit" type="primary">Save</Button>
        </Space>
      </div>
    </Form>
  </div>
})